// Avisos fiscales (no bloquean) al leer el XML de una factura de proveedor:
// - el RegimenFiscalReceptor del CFDI no es ninguno de los regimenes de la empresa
// - si los conceptos son objeto de impuesto o no (ObjetoImp)
// Lo usan Agregar Factura sin OC, Recibir Factura de OC y Agregar Factura de Caja Chica.
import axios from "axios";
import { notification } from "antd";

// Catalogo c_ObjetoImp del SAT (CFDI 4.0)
export const OBJETO_IMP = {
  "01": "No objeto de impuesto",
  "02": "Sí objeto de impuesto",
  "03": "Sí objeto del impuesto y no obligado al desglose",
  "04": "Sí objeto del impuesto y no causa impuesto",
  "05": "Sí objeto del impuesto, IVA crédito PODEBI",
  "06": "Sí objeto del IVA, no traslado IVA",
  "07": "No traslado del IVA, sí desglose IEPS",
  "08": "No traslado del IVA, no desglose IEPS",
};

const textoRegimen = (regimen) => `${regimen.c_RegimenFiscal} - ${regimen.descripcion}`;

const textoObjetoImp = (codigo) => (OBJETO_IMP[codigo] ? `${codigo} - ${OBJETO_IMP[codigo]}` : codigo);

// Funcion pura: recibe los atributos de cfdi:Receptor, los hijos de cfdi:Conceptos,
// los regimenes de la empresa ({ c_RegimenFiscal, descripcion }) y el catalogo completo.
// Regresa los textos a mostrar; null cuando no hay nada que avisar.
export const resumirAvisosFiscalesXml = ({ receptor, conceptos, regimenesEmpresa, catalogoRegimenes }) => {
  let regimen = null;
  const codigoXml = receptor?.RegimenFiscalReceptor;
  // CFDI 3.3 no trae el regimen del receptor; sin el de la empresa tampoco hay contra que comparar
  if (codigoXml && regimenesEmpresa?.length > 0) {
    const coincide = regimenesEmpresa.some((r) => Number(r.c_RegimenFiscal) === Number(codigoXml));
    if (!coincide) {
      const delCatalogo = (catalogoRegimenes || []).find((r) => Number(r.c_RegimenFiscal) === Number(codigoXml));
      const regimenXml = delCatalogo ? textoRegimen(delCatalogo) : codigoXml;
      regimen = `El XML trae el régimen ${regimenXml}, pero la empresa tiene ${regimenesEmpresa.map(textoRegimen).join(", ")}.`;
    }
  }

  let objetoImp = null;
  const conteo = {};
  (conceptos || []).forEach((concepto) => {
    const codigo = concepto?.attributes?.ObjetoImp;
    if (codigo) conteo[codigo] = (conteo[codigo] || 0) + 1;
  });
  const codigos = Object.keys(conteo).sort();
  // CFDI 3.3 no trae ObjetoImp en los conceptos
  if (codigos.length === 1) {
    objetoImp = { message: `Objeto de impuesto: ${textoObjetoImp(codigos[0])}`, description: null };
  } else if (codigos.length > 1) {
    objetoImp = {
      message: "Objeto de impuesto: los conceptos vienen mezclados",
      description: codigos
        .map((codigo) => `${conteo[codigo]} ${conteo[codigo] === 1 ? "concepto" : "conceptos"}: ${textoObjetoImp(codigo)}`)
        .join(" · "),
    };
  }

  return { regimen, objetoImp };
};

// Consulta los regimenes de la empresa y muestra los avisos. Nunca truena: si algo falla,
// la lectura del XML sigue igual.
export const avisarRegimenYObjetoImpXml = async ({ receptor, conceptos, empresaId, headersToken }) => {
  try {
    let regimenesEmpresa = [];
    let catalogoRegimenes = [];
    if (receptor?.RegimenFiscalReceptor) {
      const [resEmpresa, resCatalogo] = await Promise.all([
        axios.post("ventas/selectDatosParaRegimen", { empresaId }, { headers: headersToken }),
        axios.post("regimenfiscal/selectRegimenesFiscales", { empresaId }, { headers: headersToken }),
      ]);
      catalogoRegimenes = Array.isArray(resCatalogo.data) ? resCatalogo.data : [];
      if (resEmpresa.data?.success === 2) {
        const idsEmpresa = [resEmpresa.data.regimenDefaultId, ...(resEmpresa.data.regimenesFiscales || []).map((r) => r._id)]
          .filter(Boolean)
          .map(String);
        regimenesEmpresa = catalogoRegimenes.filter((r) => idsEmpresa.includes(String(r._id)));
      }
    }

    const { regimen, objetoImp } = resumirAvisosFiscalesXml({ receptor, conceptos, regimenesEmpresa, catalogoRegimenes });

    if (regimen) {
      notification.warning({
        key: "xmlRecibidoRegimenFiscal",
        message: "Régimen fiscal del receptor distinto al de la empresa",
        description: regimen,
        duration: 0,
      });
    } else {
      notification.close("xmlRecibidoRegimenFiscal");
    }

    if (objetoImp) {
      notification.info({
        key: "xmlRecibidoObjetoImp",
        message: objetoImp.message,
        description: objetoImp.description,
        duration: 10,
      });
    } else {
      notification.close("xmlRecibidoObjetoImp");
    }
  } catch (err) {
    console.log(err);
  }
};
